module.exports = __webpack_public_path__ + "static/gallery09-334124bc0e9c8dc543d206c470025dc3.jpg";